export const GET_PROFILE_DETAILS = 'GET_PROFILE_DETAILS';
export const GET_LANGUAGES = 'GET_LANGUAGES';
export const GET_INTERESTS = 'GET_INTERESTS';
export const USER_ADDRESSES = 'USER_ADDRESSES';
export const CART_SELECTED_ADDRESS = 'CART_SELECTED_ADDRESS';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';